export const Logo = () => (
  <a
    href="/"
    data-testid="header-logo-link"
    aria-label="AgriYuvaa home"
    className="ag-focus block rounded-lg transition-opacity duration-300 hover:opacity-85"
  >
    <img
      src="/logo.png"
      alt="AgriYuvaa"
      width="838"
      height="171"
      data-testid="header-logo-image"
      className="h-7 w-auto sm:h-9"
    />
  </a>
);
